import {
    CART_WRAPPER_CLOSE,
    CART_WRAPPER_OPEN,
    PARTICIPANTS_SELECT_CLOSE,
    PARTICIPANTS_SELECT_OPEN,
    QUESTION_MODAL_CLOSE,
    QUESTION_MODAL_OPEN
} from "../../../utils/internalEvents";
/**
 *
 *  ====== SWISSACTIVITIES CUSTOM SCRIPTS =====
 *
 */


export const initChatListener = () => {
    /**
     * If guests select is open, hide chat wrapper;
     */
    $(document).on(`${PARTICIPANTS_SELECT_OPEN} ${QUESTION_MODAL_OPEN} ${CART_WRAPPER_OPEN}`, function(){
        $('#wh-widget-send-button').fadeOut(100);
    });

    $(document).on(`${PARTICIPANTS_SELECT_CLOSE} ${QUESTION_MODAL_CLOSE} ${CART_WRAPPER_CLOSE}`, function(){
        $('#wh-widget-send-button').fadeIn(100);
    });
};


